/** Invoices shown per page. */
const INVOICES_PER_PAGE = 3;

/** Pagination starts here, and returns here when the year changes. */
const FIRST_PAGE = 1;

/** Fee name that marks an invoice as US sales tax rather than VAT. */
const US_SALES_TAX_FEE_NAME = "US_SALES_TAX";

/** Entry types carrying the sales-tax totals a sales-tax invoice prints. */
const SALES_TAX_ENTRY_TYPE = {
  addOns: "ADD_ON_SALES_TAX",
  spaceRental: "SPACE_RENTAL_SALES_TAX",
} as const;

/** Elements of the PDF page that are hidden on screen. */
const PDF_ELEMENT_ID = {
  logo: "peerspace-logo",
  page: "invoice-pdf-page",
} as const;

/** Where the PDF is rendered before being captured. */
const PDF_CONTAINER_ID = "tax-invoice-container";

/** Contracts are looked up in batches of this many entries. */
const CONTRACT_LOOKUP_CHUNK_SIZE = 25;

/** Peerspace bills EU guests from its Dutch entity. */
const EU_REGION_CODE = "EU";
const EU_ADDRESS_COUNTRY = "NL";

export {
  CONTRACT_LOOKUP_CHUNK_SIZE,
  EU_ADDRESS_COUNTRY,
  EU_REGION_CODE,
  FIRST_PAGE,
  INVOICES_PER_PAGE,
  PDF_CONTAINER_ID,
  PDF_ELEMENT_ID,
  SALES_TAX_ENTRY_TYPE,
  US_SALES_TAX_FEE_NAME,
};
